import { DSBadge, DSSurfaceColorType, DSText, DSTextColorType } from '@zoe/ds-web'
import React from 'react'

import { FragmentComponent } from '@/types/graphql'

export type BadgeRecord = {
  __typename: 'BadgeRecord'
  id: string
  label: string
  surfaceColor: DSSurfaceColorType
  textColor: DSTextColorType
  size: 'small' | 'regular' | 'large'
  dataTestId: string
}

const fragment = `
  fragment BadgeBlockFragment on BadgeRecord {
    __typename
    id
    label
    surfaceColor
    textColor
    size
    dataTestId
  }
`

export const BadgeBlock: FragmentComponent<{}, BadgeRecord> = ({ record }) => {
  return (
    <DSBadge
      surfaceColor={record.surfaceColor || 'neutral'}
      testId={record.dataTestId}
      size={record.size || 'small'}
      textColor={record.textColor || 'primary'}
    >
      <DSText variant="fluid-label-100" weight="semiBold" color={record.textColor || 'primary'}>
        {record.label}
      </DSText>
    </DSBadge>
  )
}

BadgeBlock.fragment = fragment
BadgeBlock.recordName = 'BadgeRecord'
